module.exports = __webpack_public_path__ + "img/29.f10baf30.png";